export const documentGroups = [
  { key: "pdv", label: "Dödligt våld (PDV)" },
  { key: "bombhot", label: "Bombhot" },
  { key: "brand", label: "Brandlarm" },
  { key: "olycka", label: "Olycka" },
  { key: "ovrigt", label: "Övrigt" },
];
